<template>
  <div>
    <el-dialog title="上传图片" append-to-body :modal-append-to-body="true" v-model="uploadModal"
      :width="isIframe ? '100%' : '800px'" :fullscreen="isIframe" @close="closed" top="5vh">
      <div class="main" v-loading="loading">
        <el-form :model="ruleForm" :rules="rules" ref="ruleFormRef" label-width="100px" class="demo-ruleForm">
          <el-form-item label="上传方式：" prop="type">
            <el-radio-group v-model="ruleForm.type" @change="radioChange(ruleForm.type)">
              <el-radio :value="0">本地上传</el-radio>
              <el-radio :value="1">网络上传</el-radio>
              <el-radio :value="2">扫码上传</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="上传至分组：" prop="region" v-show="ruleForm.type === 0 || ruleForm.type === 1">
            <el-cascader class="form-width" v-model="ruleForm.region" :props="cascaderProps" :options="categoryList"
              @change="handleChange"></el-cascader>
          </el-form-item>
          <el-form-item label="网络图片：" prop="region" v-if="ruleForm.type === 1">
            <el-input class="form-width" v-model="webImgUrl" placeholder="请填写网络图片地址"></el-input>
            <span class="tq-text" @click="getImg">提取照片</span>
          </el-form-item>
          <el-form-item label="上传图片：" prop="region" v-if="ruleForm.type === 0">
            <div class="acea-row">
              <div class="uploadCont">
                <el-upload ref="uploadRef" :action="fileUrl" list-type="picture-card" :on-change="fileChange"
                  :file-list="ruleForm.imgList" :auto-upload="false" :data="uploadData" :headers="myHeaders"
                  :before-upload="beforeUpload" :multiple="true" :limit="limit">
                  <template #default>
<!--                    <i class="el-icon-plus"></i>-->
                    <el-icon><Plus /></el-icon>
                  </template>
                  <template #file="{ file }">
                    <!-- 根节点必须始终存在。条件不成立时插槽会交出 null，上传列表更新就会报 vnode.type -->
                    <div
                      draggable="false" @dragstart="handleDragStart($event, file)"
                      @dragover="handleDragOver($event, file)" @dragenter="handleDragEnter($event, file)"
                      @dragend="handleDragEnd($event, file)">
                      <template v-if="file.name && ['png', 'jpg', 'gif', 'jepg', 'svg','avif'].indexOf(file.name.substr(file.name.lastIndexOf('.') + 1)) != -1">
                        <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
<!--                      <i class="el-icon-error btndel" @click="handleWebRemove(file)" />-->
                        <el-icon class=" el-icon-error btndel" @click="handleWebRemove(file)"><CircleClose /></el-icon>
                      </template>
                    </div>
                  </template>
                </el-upload>
                <div class="tips">一次最多上传50张，建议上传图片最大宽度750px，不超过5MB；单次最多一次上传20张，仅支持jpeg、png格式，可拖拽调整上传顺序</div>
              </div>
            </div>
          </el-form-item>
          <template v-if="ruleForm.type === 1">
            <div class="img-box pl100">
              <div v-for="(item, index) in ruleForm.imgList" :key="index" class="pictrue" draggable="false"
                @dragstart="handleDragStart($event, item)" @dragover.prevent="handleDragOver($event, item)"
                @dragenter="handleDragEnter($event, item)" @dragend="handleDragEnd($event, item)">
                <img :src="item.url" />
<!--                <i class="el-icon-error btndel" @click="handleRemove(index)" />-->
                <el-icon class=" el-icon-error btndel" @click="handleRemove(index)"><CircleClose /></el-icon>

              </div>
            </div>
          </template>
          <div class="code-image" v-if="ruleForm.type === 2">
            <div class="left">
              <el-form-item label="上传至分组：" prop="region">
                <el-cascader class="form-width" v-model="ruleForm.region" :props="cascaderProps" :options="categoryList"
                  @change="handleChange"></el-cascader>
              </el-form-item>
              <el-form-item label="二维码：" prop="region">
                <!-- 包一层列布局：EP form-item content 默认 flex 行，否则提示会跑到二维码右侧 -->
                <div class="qr-block">
                  <div class="code">
                    <QRCodeVue3 v-if="qrcodeUrl" :value="qrcodeUrl" :size="160" level="H" render-as="svg" />
                    <div v-else class="qr-pending">等待生成二维码...</div>
                  </div>
                  <div class="trip">扫描二维码，快速上传手机图片</div>
                  <div class="trip-small">建议使用手机浏览器</div>
                </div>
              </el-form-item>
            </div>
            <div class="right">
              <el-button size="small" @click="scanUploadGetFun">刷新图库</el-button>
              <div class="tip">刷新图库按钮，可显示移动端上传成功的图片</div>
              <div class="img-box">
                <div v-for="(item, index) in ruleForm.imgList" :key="index" class="pictrue" draggable="false"
                  @dragstart="handleDragStart($event, item)" @dragover.prevent="handleDragOver($event, item)"
                  @dragenter="handleDragEnter($event, item)" @dragend="handleDragEnd($event, item)">
                  <img :src="item.attachmentSrc" />
                  <!-- <i class="el-icon-error btndel" @click="handleWebRemove(item)" /> -->
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button size="small" @click="clear">取 消</el-button>
          <el-button size="small" type="primary" @click="submitUpload">确 定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup lang="ts">
// +----------------------------------------------------------------------
// | EB [ EB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2024 https://www.eb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed EB并不是自由软件，未经许可不能去掉EB相关版权
// +----------------------------------------------------------------------
// | Author: EB Team <admin@eb.com>
// +----------------------------------------------------------------------

import { ref, reactive, watch, onBeforeUnmount } from 'vue'
import { getToken } from "@/utils/auth"
import { fileUpload, scanUploadQrcode, scanUploadGet, onlineUpload, scanUploadSave } from '@/api/setting'
import QRCodeVue3 from 'qrcode.vue'
import compressImg from '@/utils/compressImg'
import SettingMer from "@/libs/settingMer";
import {ElMessage} from "element-plus";


interface Props {
  categoryList: any[]
  categoryId: string | number
  isPage: boolean
  isIframe: boolean
}

interface Emits {
  (e: 'uploadSuccess'): void
}

interface RuleForm {
  type: number
  region: number | string
  imgList: any[]
}

interface CascaderProps {
  checkStrictly: boolean
  emitPath: boolean
  label: string
  value: string
}

interface ApiResponse {
  data: any
  message: string
  status?: number
}

// 适配 Axios 响应类型
interface AxiosApiResponse {
  data: ApiResponse
  status: number
  statusText: string
  headers: any
  config: any
}

const props = withDefaults(defineProps<Props>(), {
  categoryList: () => [],
  categoryId: '',
  isPage: false,
  isIframe: false
})

const emit = defineEmits<Emits>()

// 响应式数据
const webImgUrl = ref('')
const uploadModal = ref(false)
const fileUrl = ref(SettingMer.https + `/upload/image/0/file`)
const myHeaders = reactive({
  'Authorization': 'Bearer ' + getToken(),
})

const uploadData = reactive<{ pid?: number | string }>({})
const cascaderProps: CascaderProps = {
  checkStrictly: true,
  emitPath: false,
  label: 'attachmentCategoryName',
  value: 'attachmentCategoryId'
}
const disabled = ref(false)
const ruleForm = reactive<RuleForm>({
  type: 0,
  region: 0,
  imgList: [],
})
const rules = {
  type: [{ required: true, message: '请选择活动资源', trigger: 'change' }]
}
const qrcode = ref('')
const qrcodeUrl = ref('')
const scanToken = ref('')
const limit = ref(50)
const loading = ref(false)
const time = ref<NodeJS.Timeout | undefined>(undefined)
const dragging = ref<any>(null)

// 模板引用
const ruleFormRef = ref()
const uploadRef = ref()

// 监听器
watch(uploadModal, (newVal) => {
  if (newVal) ruleForm.region = props.categoryId
}, { immediate: true })

// 生命周期
onBeforeUnmount(() => {
  if (time.value) {
    clearInterval(time.value)
    time.value = undefined
  }
})

// EP radio 的 change 在 nextTick 才发出，v-model 会先渲染。
// 网络图只有 url、没有 name，本地上传列表一渲染就会在 file.name.substr 上报错
watch(
  () => ruleForm.type,
  () => {
    ruleForm.imgList = []
  },
)

// 方法
const radioChange = (type: number) => {
  ruleForm.type = type
  ruleForm.imgList = []
  if (time.value) {
    clearInterval(time.value)
    time.value = undefined
  }
  if (type === 2) {
    scanUploadQrcodeFun()
    time.value = setInterval(() => {
      scanUploadGetFun()
    }, 2000)
  }
}

const scanUploadQrcodeFun = () => {
  scanUploadQrcode(ruleForm.region).then((res: any) => {
    // 兼容 DataObj / 误包一层：{ data: { url } } 或 { data: { data: { url } } }
    const payload = res?.data
    const url =
      (typeof payload === 'string' ? payload : '') ||
      payload?.url ||
      payload?.data?.url ||
      ''
    if (!url) {
      console.error('扫码上传二维码响应异常:', res)
      ElMessage.error('获取二维码失败')
      return
    }
    scanToken.value = url
    creatQrCode(url)
  }).catch((error: any) => {
    console.error('获取二维码失败:', error)
    ElMessage.error(error?.message || '获取二维码失败')
  })
}

const scanUploadGetFun = () => {
  if (!scanToken.value) return
  const token = scanToken.value.split('token=')[1]
  if (!token) return
  scanUploadGet(token).then((res: any) => {
    ruleForm.imgList = res.data || []
  })
}

const getImg = () => {
  if (!webImgUrl.value) {
    ElMessage.error('请先输入图片地址')
    return
  }
  ruleForm.imgList.push({
    url: webImgUrl.value,
  })
}

const submitUpload = async () => {
  if (ruleForm.imgList.length <= 0) {
    ElMessage.error('请上传图片')
    return
  }

  if (ruleForm.type === 0) {
    uploadData.pid = ruleForm.region
    if (ruleForm.imgList.length) {
      if (loading.value) return
      loading.value = true
      try {
        for (let i = 0; i < ruleForm.imgList.length; i++) {
          const file = ruleForm.imgList[i].raw
          await uploadItem(file)
        }
        ElMessage.success('上传成功')
        emit('uploadSuccess')
        uploadModal.value = false
        initData()
      } catch (err: any) {
        ElMessage.error(err?.message || '上传失败')
      } finally {
        loading.value = false
      }
    }
  } else if (ruleForm.type === 1) {
    const urls = ruleForm.imgList.map((e) => {
      return e.url
    })
    if (urls.length) {
      if (loading.value) return
      loading.value = true
      onlineUpload({ id: ruleForm.region, images: urls })
        .then((res: any) => {
          ElMessage.success('上传成功')
          emit('uploadSuccess')
          uploadModal.value = false
          loading.value = false
          initData()
        })
        .catch((err: any) => {
          loading.value = false
          // 对齐 EB uploadImg：业务失败由页面提示，拦截器对 status!==200 只 reject 不弹窗
          console.error(err.message)
          ElMessage.error(err?.message || '上传失败')
        })
    }
  } else if (ruleForm.type === 2) {
    if (!scanToken.value) {
      ElMessage.error('二维码未就绪，请稍后重试')
      return
    }
    const token = scanToken.value.split('token=')[1]
    if (!token) {
      ElMessage.error('二维码无效，请刷新后重试')
      return
    }
    const attId = ruleForm.imgList.map((e) => {
      return e.attachmentId
    })
    scanUploadSave(token, { pid: ruleForm.region, ids: attId }).then((res: any) => {
      ElMessage.success(res.message || '扫码上传成功')
      emit('uploadSuccess')
      uploadModal.value = false
      initData()
    })
  }
}

const uploadItem = (file: File): Promise<void> => {
  return new Promise((resolve, reject) => {
    const formData = new FormData()
    formData.append('file', file)
    fileUpload(ruleForm.region, formData)
      .then((res: any) => {
        // console.log('fileUpload res ',res)
        if (res.status === 200) {
          resolve()
        } else {
          reject(new Error(res.message || '上传失败'))
        }
      })
      .catch((err: any) => {
        reject(err)
      })
  })
}

const beforeUpload = (file: File) => {
  // 可以在这里添加文件验证逻辑
}

const creatQrCode = (url: string) => {
  // 对齐管理端：用 qrcode.vue SVG 渲染，避免 qrcode 包 canvas getContext 报错
  qrcodeUrl.value = url || ''
}

const handleWebRemove = (file: any) => {
  const index = ruleForm.imgList.findIndex((e) => {
    return e.url === file.url
  })
  ruleForm.imgList.splice(index, 1)
}

const handleRemove = (index: number) => {
  ruleForm.imgList.splice(index, 1)
}

const fileChange = async (file: any, fileList: any[]) => {
  if (['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/webp','image/avif'].indexOf(file.raw.type) === -1) {
    // 过滤出有效的图片文件
    let validFiles = ruleForm.imgList.filter(item => {
      const isImage = item.raw && item.raw.type.startsWith('image/');
      const isValidType = ['image/jpeg','image/png','image/jpg','image/gif','image/webp'].includes(item.raw.type);
      return isImage && isValidType;
    });
    // 更新文件列表，只保留有效文件
    ruleForm.imgList = validFiles;
    ElMessage.error('请上传正确的文件格式！')
    return
  } else {
    if (file.size >= 2097152) {
      await comImg(file.raw).then((res) => {
        fileList.forEach((e) => {
          // if (e.uid === file.uid) {
          //   e.raw = res;
          // }
        })
        ruleForm.imgList = fileList
      })
    } else {
      ruleForm.imgList = fileList
    }
  }
}

const comImg = (file: File): Promise<any> => {
  return new Promise((resolve) => {
    compressImg(file).then((res) => {
      resolve(res)
    })
  })
}

const handleChange = (e: any) => {
  fileUrl.value = SettingMer.https + `/upload/image/${ruleForm.region}/file`
  if (ruleForm.type === 2) scanUploadQrcodeFun()
}

// 拖拽相关方法 - 完整实现
const handleDragStart = (e: DragEvent, item: any) => {
  dragging.value = item
}

const handleDragEnd = (e: DragEvent, item: any) => {
  dragging.value = null
}

const handleDragOver = (e: DragEvent) => {
  if (e.dataTransfer) {
    e.dataTransfer.dropEffect = 'move'
  }
}

const handleDragEnter = (e: DragEvent, item: any) => {
  if (e.dataTransfer) {
    e.dataTransfer.effectAllowed = 'move'
  }
  if (item === dragging.value) {
    return
  }
  const newItems = [...ruleForm.imgList]
  const src = newItems.indexOf(dragging.value)
  const dst = newItems.indexOf(item)
  newItems.splice(dst, 0, ...newItems.splice(src, 1))
  ruleForm.imgList = newItems
}

const closed = () => {
  initData()
}

const clear = () => {
  uploadModal.value = false
  initData()
}

const initData = () => {
  ruleForm.type = 0
  ruleForm.region = 0
  scanToken.value = ''
  qrcodeUrl.value = ''
  webImgUrl.value = ''
  ruleForm.imgList = []
  if (time.value) {
    clearInterval(time.value)
    time.value = undefined
  }
}

// 暴露方法供父组件调用
defineExpose({
  uploadModal,
  initData
})
</script>

<style lang="scss" scoped>

.main {
  min-height: 400px
}

.pictrue {
  width: 64px;
  height: 64px;
  border: 1px dotted rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin-right: 10px;
  position: relative;
  cursor: pointer;

  img {
    border-radius: 4px;
    width: 100%;
    height: 100%;
  }
}

.btndel {
  position: absolute;
  z-index: 1;
  font-size: 18px;
  right: -5px;
  top: -5px;
  color: #999;
}

.form-width {
  width: 280px;
}

/* cascader 内部 input 高度偏矮，与默认表单项对齐 */
:deep(.el-cascader .el-input) {
  line-height: 32px;
  --el-input-height: 32px;
}
:deep(.el-cascader .el-input__wrapper) {
  min-height: 32px !important;
}

.tq-text {
  margin-left: 14px;
  font-size: 12px;
  font-weight: 400;
  color: var(--prev-color-primary);
  cursor: pointer;
}

:deep(.el-upload--picture-card),
:deep(.el-upload-list--picture-card .el-upload-list__item) {
  width: 64px;
  height: 64px;
  line-height: 72px;
  overflow: inherit;
  border: 1px dotted rgba(0, 0, 0, 0.1);
}

:deep(.el-upload--picture-card),
:deep(.el-upload-list--picture-card .el-upload-list__item img) {
  width: 64px;
  height: 64px;
  border-radius: 4px;
  object-fit: cover;

}

.pl100 {
  padding-left: 100px;
}

.img-box {
  display: flex;
  flex-wrap: wrap;
}

.tips {
  font-size: 12px;
  color: #BBBBBB;
}

.code-image {
  display: flex;
  margin-top: 12px;

  .left {
    display: flex;
    flex-direction: column;
    margin-right: 20px;
    align-items: flex-start;

    .qr-block {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .code {
      border: 1px solid #DDDDDD;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 200px;
      height: 200px;
      border-radius: 4px;
      margin-bottom: 14px;

      .code-img {
        width: 160px;
        height: 160px;
      }
    }

    .qr-pending {
      padding: 20px;
      text-align: center;
      color: #999;
      font-size: 13px;
    }

    .form-width {
      width: 200px;
    }

    .trip {
      color: #333333;
      text-align: center;
      line-height: 18px;
    }

    .trip-small {
      font-size: 12px;
      font-weight: 400;
      color: #BBBBBB;
      text-align: center;
      line-height: 16px;
    }
  }

  .right {
    margin-top: 62px;

    .tip {
      font-size: 12px;
      font-weight: 400;
      color: #BBBBBB;
      margin: 10px 0;
    }

  }
}
</style>
